/**
 * Moderation status for city attractions.
 * Seed/admin entries are created as `approved`.
 * Partner-created points start as `needReview`.
 */
export enum AttractionReviewStatusEnum {
    APPROVED = 'approved',
    NEED_REVIEW = 'needReview',
    REJECTED = 'rejected',
    /** Rejected by city-content MCP agent (not human moderator). */
    REJECTED_MCP = 'rejected_mcp',
}
